
angular.module('bmsApp.directives').controller('ActivityModalFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$filter',
	'$modalInstance',
	'$ngBootbox',
	'ConfigService',
	'CustomerSvc',
	'EmployeeOptionsSvc',
	'ActivitySvc',
	'ActivityTypeSvc',
	'EnquirySvc',
	'activity', function (
		$scope,
		$q,
		$timeout,
		$filter,
		$modalInstance,
		$ngBootbox,
		ConfigService,
		CustomerSvc,
		EmployeeOptionsSvc,
		ActivitySvc,
		ActivityTypeSvc,
        EnquirySvc,
		activity) {

		if (activity.activity_start_date === null) {
			activity.activity_start_date = moment();
			activity.activity_end_date = activity.activity_start_date.add(1, 'hour');
		}
		
		$scope.isEnquiry = angular.isDefined(activity.isEnquiry);

		$scope.modelSelectedChange = function(model){
			if(model == 'customer'){
                $scope.activity.enquiry = null;
			}else if(model == 'enquiry'){
				$scope.activity.customer = null;
			}
		};

		$scope.config = ConfigService.config;

		$scope.uiTimePickerOptions = angular.extend({}, angular.copy($scope.config.uiTimePickerOptions), {
			appendTo: '.modal-content'
		});
		$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
			options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
				parentEl: '.modal-content'
			})
		});
		$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
			storageFormat: 'YYYY-MM-DD',
			options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
				format: 'MMMM Do YYYY',
				parentEl: '.modal-content'
			})
		});


		// watch the start and end dates and update each other as necessary
		$scope.$watch('activity.activity_start_date', function (newValue) {
			if (angular.isObject($scope.activity) && newValue !== null) {
				$scope.activity.activity_start_date_date = newValue.format($scope.datePickerConfig.storageFormat);
			}
		});

		$scope.updateActivityStartDate = function () {
			$timeout(function () {
				$scope.$apply(function () {
					if (angular.isObject($scope.activity)) {
						var activityStartDateDate = moment($scope.activity.activity_start_date_date);
						$scope.activity.activity_start_date.year(activityStartDateDate.year()).month(activityStartDateDate.month()).date(activityStartDateDate.date());
					}
				});
			});
		};

		$scope.$watch('activity.activity_end_date', function (newValue) {
			if (angular.isObject($scope.activity) && newValue !== null) {
				$scope.activity.activity_end_date_date = newValue.format($scope.datePickerConfig.storageFormat);
			}
		});

		$scope.updateActivityEndDate = function () {
			$timeout(function () {
				$scope.$apply(function () {
					if (angular.isObject($scope.activity)) {
						var activityEndDateDate = moment($scope.activity.activity_end_date_date);
						$scope.activity.activity_end_date.year(activityEndDateDate.year()).month(activityEndDateDate.month()).date(activityEndDateDate.date());
					}
				});
			});
		};

		var promises = [
			CustomerSvc.options()
				.then(function (response) {
					$scope.customerOptions = response.data.options;
					$scope.customerOptions = $filter('filter')($scope.customerOptions, function(item) {
						return item.customer_status.value !== 'Inactive';
					});
				}),
			EmployeeOptionsSvc.employee({filter: {status: true}})
				.then(function (response) {
					$scope.employeeOptions = response.data.options;
				}),
			ActivitySvc.scheduleDurationTypeOptions()
				.then(function (response) {
					$scope.scheduleDurationTypeOptions = response.data.options;
				}),
			ActivitySvc.reoccurenceTypeOptions()
				.then(function (response) {
					$scope.reoccurenceTypeOptions = response.data.options;
				}),
			ActivitySvc.status.options()
				.then(function (response) {
					$scope.activityStatusOptions = response.data.options;
				}),
			ActivityTypeSvc.index()
				.then(function (response) {
					$scope.activityTypes = response.data.activityTypes;
				}),
			EnquirySvc.options()
				.then(function (response) {
					$scope.enquiryOptions = response.data.options;
				})
		];
		$scope.loading = true;
		$scope.processing = false;
		$q.all(promises)
			.then(function () {
				$timeout(function () {
					$scope.$apply(function () {
						// fill the start and end time fields if activity already saved
						if (activity.id) {
							activity.activity_start_date = moment(activity.activity_start_date);
							activity.activity_start_date_time = moment(activity.activity_start_date)
								.format('HH:mm');
							activity.activity_end_date = moment(activity.activity_end_date);
							activity.activity_end_date_time = moment(activity.activity_end_date)
								.format('HH:mm');
						}

						$scope.activity = angular.extend({
							// 9am today
							activity_start_date: moment('09:00:00', 'HH:mm:ss'),
							activity_end_date: moment('10:00:00', 'HH:mm:ss'),
							mon: 0,
							tue: 0,
							wed: 0,
							thu: 0,
							fri: 0,
							sat: 0,
							sun: 0,
							reoccur_until: null,
							reoccurence_type: 'Does not repeat',
							activity_schedules: [],
							activity_type: [],
						}, activity);

						$scope.loading = false;
					});
				}, 0);
			});

		$scope.reoccurenceTypeChange = function (activity) {
			if (activity.reoccurence_type === 'Does not repeat') {
				// clear recurrence date
				activity.reoccur_until = null;
			}

			if (activity.reoccurence_type === 'Weekly') {
				// reset days of week
				angular.extend(activity, {
					mon: 0,
					tue: 0,
					wed: 0,
					thu: 0,
					fri: 0,
					sat: 0,
					sun: 0
				});
			}

			if (activity.reoccurence_type === 'Monthly') {
				// reset monthly type
				activity.reoccurence_type_monthly = 'MONTH';
			}
		};

		$scope.addReminder = function () {
			$scope.activity.activity_schedules.push({});
		};

		$scope.removeReminder = function (reminder) {
			if (reminder.id) {
				reminder.delete = true;
			}
			else {
				var index = $scope.activity.activity_schedules.indexOf(reminder);
				$scope.activity.activity_schedules.splice(index, 1);
			}
		};

		$scope.delete = function(activity) {
			$ngBootbox.confirm('Are you sure you want to delete this activity?')
				.then(function () {
				    ActivitySvc.delete(activity).then(function(response){
                        var modalResult = {};
                        modalResult.success = response.data.success;
                        $modalInstance.close(modalResult);
                    });
				});
		};

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				if ($scope.activity.activity_end_date.isAfter($scope.activity.activity_start_date) !== true) {
					$scope.errors = [
						'To date must be after from date'
					];
					return false;
				}

				$scope.submit($scope.activity);
			},
			errorPlacement: function (error) {
				error.appendTo('#activity-errors');
			},
			errorContainer: '#activity-errors'
		};

		$scope.submit = function (activity) {
			$scope.processing = true;
			var modalResult = {};
			var activityCopy = angular.copy(activity);
			if	(activityCopy.enquiry == null){
				delete activityCopy.enquiry;
			}
			activityCopy.activity_start_date = activity.activity_start_date.format('YYYY-MM-DD HH:mm:ss');
			activityCopy.activity_end_date = activity.activity_end_date.format('YYYY-MM-DD HH:mm:ss');
			var savePromise = activity.id ? ActivitySvc.update(activityCopy) : ActivitySvc.create(activityCopy);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = activity.id ? 'update' : 'create';
					modalResult.activity = activity;
					$modalInstance.close(modalResult);
				}, function (error) {
					$scope.errors = error;
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

	}]);
